// fadeObserver.js

/**
 * Intersection Observer でフェード表示を行う
 * @param {string} selector - 対象要素のセレクタ
 * @param {object} options - IntersectionObserver のオプション
 * @param {boolean} withDelay - 遅延をつけるか
 */
export function observeFade(selector, options = {}, withDelay = false) {
  const elements = document.querySelectorAll(selector);

  if (withDelay) {
    elements.forEach((el, index) => {
      const parent = el.closest(".fade-area");
      const siblings = parent ? parent.querySelectorAll(selector) : elements;
      const delay = Array.from(siblings).indexOf(el) * 0.1;
      el.style.setProperty("--fade-delay", `${delay}s`);
    });
  }

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("visible");
        }
      });
    },
    { threshold: 0.3, ...options }
  );

  elements.forEach((el) => observer.observe(el));
}
